<div class="container">
  <div class="statement-title">
      Proof statement
  </div>
  <div class="statement-content">
    <textarea class="form-control" [(ngModel)]="userStatement"></textarea>
    @if (isProofing == false) {
      <button class="btn btn-primary" (click)="proofStatement()">Proof</button>
    }
  </div>
  <div class="statement-result">
    @if (isProofing) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">Proofing...</div>
      </div>
    }
    @else {
      <div class="result-title">
        Result
      </div>
      @if (proofResult != "" && proofScore > minScore) {
        <div class="result-content">
          <p>The statement is supported by the following evidence {{proofScore * 100 | number:'1.0-0'}}%:</p>
          <p>{{proofResult}}</p>
          @for (step of proofSteps; track $index) {
            <p>{{step}}</p>
          }
        </div>
      } @else {
        <div class="result-content">
          <p>No evidence found for the statement.</p>
        </div>
      }
    }
  </div>
</div>